import { cn } from '#lib/helpers/class.js';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

export default function ThemeTextsTree(props) {
    const { tree, onClick, content, path = '', level = 1 } = props;
    const state = Object?.keys(tree)?.reduce((acc, el, i) => {
        acc[el] = false;
        return acc;
    }, {});
    const [show, setShow] = useState(state);

    const orderedTree = Object.keys(tree).sort((a, b) => {
        if (typeof tree[a] === 'object') return 1;
        if (typeof tree[b] === 'object') return -1;
        return 0;
    });

    return (
        <div className="w-full h-full flex flex-col divide-y divide-neutral-200">
            {orderedTree.map((label) => {
                if (typeof tree[label] !== 'object') {
                    return (
                        <span
                            className={cn(
                                'px-3 cursor-pointer hover:text-primary-500',
                                `${path}.${label}` === content?.path && 'text-primary-500'
                            )}
                            key={label}
                            onClick={() => {
                                onClick((path ? path + '.' : '') + label);
                            }}
                        >
                            {label}
                        </span>
                    );
                } else
                    return (
                        <div key={label}>
                            <div
                                className="px-3 flex justify-between cursor-pointer flex justify-between p-1 hover:bg-neutral-200"
                                onClick={() =>
                                    setShow((state) => {
                                        const updated = structuredClone(state);
                                        updated[label] = !state[label];
                                        return updated;
                                    })
                                }
                            >
                                <span className="font-semibold">{label}</span>
                                {!show[label] ? (
                                    <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                                ) : (
                                    <ChevronUpIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                                )}
                            </div>
                            {show && show[label] && (
                                <div style={{ paddingLeft: `${level * 6}px` }} className="border-l-2">
                                    <ThemeTextsTree
                                        tree={tree[label]}
                                        level={level + 1}
                                        onClick={onClick}
                                        content={content}
                                        path={(path ? path + '.' : '') + label}
                                    />
                                </div>
                            )}
                        </div>
                    );
            })}
        </div>
    );
}
